import { render, staticRenderFns } from "./RatingSummaryItem.vue?vue&type=template&id=3fa29104&scoped=true&"
import script from "./RatingSummaryItem.vue?vue&type=script&lang=js&"
export * from "./RatingSummaryItem.vue?vue&type=script&lang=js&"
import style0 from "./RatingSummaryItem.vue?vue&type=style&index=0&id=3fa29104&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa29104",
  null
  
)

export default component.exports